import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const myRouter: Array<RouteRecordRaw> = [
    {
        path: '/my',
        name: '个人中心',
        component: Layout,
        meta: { title: '个人中心', icon: 'icon-setting', alwaysShow: true },
        children: [
            {
                path: 'edit-password',
                name: '修改密码',
                component: () => import('@/views/my/EditPassword.vue'),
                meta: { title: '修改密码' }
            },
            {
                path: 'edit-phone',
                name: '修改手机号',
                component: () => import('@/views/my/EditPhone.vue'),
                meta: { title: '修改手机号' }
            },
            {
                path: 'test',
                name: '技术测试页',
                component: () => import('@/views/my/Test.vue'),
                meta: { title: '技术测试页' }
            }
        ]
    }
]

export default myRouter